export default __webpack_public_path__ + "static/media/landscaping.42accca6.png";